<template>
	<div>
		<div class="columns">
			<div class="column table-container">
				<table class="table is-striped is-hoverable is-fullwidth is-narrow" id="customer-address-table">
					<thead>
					<tr>
						<th>{{ parameters.translation.type }}</th>
						<th>{{ parameters.translation.street }}</th>
						<th>{{ parameters.translation.number }} / {{ parameters.translation.box }}</th>
						<th>{{ parameters.translation.postal_code }}</th>
						<th>{{ parameters.translation.city }}</th>
						<th>{{ parameters.translation.contact }}</th>
						<th>&nbsp;</th>
					</tr>
					</thead>
					<tbody>

					<tr v-for="(address, index) in data.addresses">
						<td>
							<p class="tag is-fullwidth" v-for="type in address.address_type_id_all">
								<span v-if="type === 3">{{ parameters.translation.invoice_address }}</span>
								<span v-else>{{ parameters.translation.delivery_address }}</span>
							</p>
						</td>
						<td>{{address.street}}</td>
						<td>{{address.number}}<span v-if="address.box"> / {{address.box}}</span></td>
						<td>{{address.zip_code}}</td>
						<td>{{address.city}} </td>
						<td>{{address.contact}}</td>
						<td>
							<button @click="loadModal(index)"
									data-ta-event="clientarea-track.company.addresses.update-address"
									data-ta-action="Click"
									data-ta-label="Company-page – Addresses – Click on update address button"
									data-ta-page-name="MyCompanyPage"
									:data-ta-payload="JSON.stringify({'addressId': address.id})"
									class="track-action"
							>
								<i class="fa-solid edit-address fa-pen-to-square"></i>
							</button>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="columns is-centered" v-if="canAddAddress">
			<div class="column is-half">
				<div class="control has-text-centered">
					<button @click="loadModal(null)"
							class="button is-light track-action"
							data-ta-event="clientarea-track.company.addresses.add-address"
							data-ta-action="Click"
							data-ta-label="Company-page – Addresses – Click on Add address button"
							data-ta-page-name="MyCompanyPage"
					>
						{{ parameters.translation.add_title }}
					</button>
				</div>
			</div>
		</div>
		<address-form
			:address-types="parameters.type"
			:address="address"
			:country-code="countryCode"
			:urls="parameters.urls"
			:translation="parameters.translation"
			:entity-type="entityType"
			:entity-id="entityId"
			:log-url="logUrl"
			@close="closeModal"
			@save="saveModal"
			:display="displayModal"
		/>
	</div>
</template>

<script>
import {ApiMonizze} from '../api-monizze';

export default {
	data: function()
	{
		return {
			data: {
				addresses : [],
				meta : {},
				links : {},
			},
			address: null,
			displayModal: false,
		};
	},
	props: {
		url: {
			type: String,
			required: true
		},
		logUrl: {
			type: String,
			required: true
		},
		entityType : {
			type: String,
			required : true
		},
		entityId: {
			type: Number,
			required: false
		},
		parameters: {
			type: Object,
			required: true
		},
		modal: {
			type: Boolean,
			default: false,
		},
		limit: {
			type: Number,
			default: -1
		},
		countryCode: {
			type: Number,
			required: true,
			default: 1
		},
	},
	computed:{
		showPagination : function()
		{
			return this.data.links.next != null || this.data.links.prev != null;
		},
		canAddAddress : function(){
			return this.$props.limit === -1 || this.data.addresses.length < this.$props.limit;
		}
	},
	created() {
		this.getAddresses();
	},
	methods: {
		close: function()
		{
			this.$emit('close');
		},
		changePage: function()
		{
			this.getAddresses();
		},
		getAddresses : function(emitSuccess = false)
		{
			new ApiMonizze()
				.getDataFromApi(
					this.$props.url,
					(response) => {
						this.data.addresses = response
						if (emitSuccess)
						{
							this.$emit('success');
						}
					}
				);

		},
		loadModal: function(index)
		{
			this.address = index === null ? null : this.address = this.data.addresses[index];
			this.displayModal = true;
		},
		closeModal: function()
		{
			this.displayModal = false;
			this.getAddresses();
			return false;
		},
		saveModal: function()
		{
			this.displayModal = false;
			this.getAddresses(true);

			return false;
		},
	},
}
</script>
